import type { TypedString } from '#/types/TypedString';

type Props = {
  videoId: TypedString<'vimeo-video-id'>;
  width: number;
  height: number;
};

export async function getVimeoThumbnail({
  videoId,
  width,
  height,
}: Props): Promise<string | undefined> {
  const response = await fetch(
    `https://vimeo.com/api/oembed.json?url=${encodeURI(
      `https://vimeo.com/${videoId}`,
    )}&width=${width}&height=${height}`,
  );

  const text = await response.text();
  // TODO: Fix this the next time the file is edited.
  // oxlint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-return
  return JSON.parse(text).thumbnail_url;
}
